var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImpact(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    fill: "#f4a734",
    enableBackground: "new 0 0 512 512",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m30 482v-31.5h30.499v-30h-30.499v-30h30.499v-30h-30.499v-30h30.499v-30h-30.499v-30h30.499v-30h-60.499v271.5h512v-29.986h-482z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m233.93 388.5h109.9v63.764h-109.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m378.224 250.664h109.9v201.6h-109.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m89.637 421.5h109.9v30.764h-109.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m314.337 303.572v19.068h30v-71.976h-71.977v30h22.381l-114.419 79.836h-89.656v30h99.088z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m342.299 146.02c0-12.652-7.442-24.211-18.958-29.449l-50.474-26.594c12.756-6.308 21.533-19.447 21.533-34.641v-55.336h-38.63c-21.334 0-38.629 17.295-38.629 38.629v16.706c0 15.281 8.875 28.487 21.749 34.752l-50.23 26.483c-11.517 5.237-18.958 16.797-18.958 29.449v49.618h172.598v-49.617z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImpact);
export default __webpack_public_path__ + "static/media/impact.b62a5c37449f63e78cc7a64ff89e5c2d7dd30b811bf0f6461247a0262074abd9.svg";
export { ForwardRef as ReactComponent };